import React from "react";

import ReactPlayer from "react-player";

const FullscreenVideo = ({ slideType, duration, ...rest }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 5vmin)",
      }}
    >
      <ReactPlayer
        width="100%"
        height="100%"
        muted
        playing
        url={slideType?.[0]?.videoFile?.url || slideType?.[0]?.videoLink}
      />
    </div>
  );
};

export default FullscreenVideo;
